import { Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder,  UntypedFormGroup,  ValidationErrors,  Validators} from '@angular/forms';
import {ApiValidatorService} from '../../../../../core/services/api-validator.service';
import {NgbDatepicker} from '@ng-bootstrap/ng-bootstrap';
import { CardTransfer, CardTransferRequest } from 'src/app/interfaces/card-transfers';
import { Driver } from 'src/app/interfaces/driver';
import { CardTransferService } from 'src/app/core/services/card-transfers.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-driver-code-tracking-add',
  templateUrl: './driver-code-tracking-add.component.html',
  styleUrls: ['./driver-code-tracking-add.component.scss'],
})
export class DriverCodeTrackingAddComponent implements OnInit {
  @Input() cardTransfer: CardTransfer;
  @Input() driver: Driver;
  @Output() formUpdate = new EventEmitter();
  @ViewChild(NgbDatepicker) ngbDatepicker: NgbDatepicker;
  public form = this.buildForm();
  public pending = false;
  formErrors: any;

  public cardStatus = [{label: 'CARD_DAMAGED', value: 2}, {label: 'CARD_LOST', value: 3}];

  constructor(
    private fb: FormBuilder,
    private apiValidator: ApiValidatorService,
    private cardTransferService: CardTransferService) {
  }

  errorCallback() {
    this.pending = false;
    // this.formErrors = err;
    // this.cd.detectChanges();
  }
  ngOnInit() {
    this.buildForm();
    if (this.cardTransfer) {
      this.form.patchValue(this.cardTransfer);
      this.form.controls.cardNumber.disable();
      this.form.controls.returnDate.setValidators([Validators.required]);
      this.form.setValidators([this.returnDateValidator]);
      this.setDateFields(['transferDate', 'returnDate'], this.form as UntypedFormGroup, this.cardTransfer);
    }
  }

  returnDateValidator(form: AbstractControl): ValidationErrors | null {
    const transferDate: Date | null = form.get('transferDate')?.value;
    const returnDate: Date | null = form.get('returnDate')?.value;
    if (!transferDate || !returnDate) {
      return null; // If either date is missing, consider it valid (other validators handle required)
    }
    return returnDate >= transferDate ? null : { invalidFinishAt: { valid: false} };
  }

  setDateFields(dates: string[], form: UntypedFormGroup, object: any) {
      dates.forEach(value => {
        if (object[value]) {
          form.get(value).patchValue(new Date(object[value]));
        }
      });
    }

  buildForm() {
    return  this.fb.group({
      cardNumber: this.fb.control<string>(null, Validators.required),
      transferDate: this.fb.control<Date>(null, Validators.required),
      returnDate: [null],
      status: [null],
    });
  }


  buildData(): CardTransfer {
    if (!this.driver) {
      return;
    }
    const data: Partial<CardTransferRequest> = {...this.form.value};
    data.driverId = this.driver.id;
    return data as CardTransfer;
  }


  save() {
    if (this.pending || !this.apiValidator.formIsValid(this.form)) {
      return;
    }
    this.pending = true;
    if (this.cardTransfer) {
      const data = this.buildData();
      this.cardTransferService.partialUpdate(this.cardTransfer.id, {
        returnDate: data.returnDate,
        transferDate: data.transferDate,
        status: data.status,
      }).subscribe(res => {
        this.formUpdate.emit(res);
        this.driver.cardId = null;
      }, this.errorHandler.bind(this));
    } else {
      this.cardTransferService.add(this.buildData()).subscribe(res => {
        this.cardTransfer = res;
        this.formUpdate.emit(res);
        this.driver.cardId = this.cardTransfer.cardNumber;
      }, this.errorHandler.bind(this));
    }

  }

  handlerCancel() {
    this.formUpdate.emit();
  }

  stopEvents(input: HTMLInputElement) {
    input.blur();
  }

  errorHandler(response: HttpErrorResponse) {
      this.pending = false;
      if (response?.error?.data?.message) {
        this.formErrors = { name: response?.error?.data?.message};
      } else {
        this.formErrors = response.error;
      }
      console.log(this.formErrors);
  }

}
